<template>
  <div>
    <b-card>
      <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2">
          <!-- Forgot Password v1 -->
          <b-card class="mb-0">
            <b-link class="brand-logo">
              <!-- logo -->
              <dutton-logo />
              <h2 class="brand-text text-primary ml-1">
                Dutton GT
              </h2>
            </b-link>
            <b-card-title class="mb-1">
              ¿Olvidaste tu contraseña? 🔒
            </b-card-title>
            <b-card-text class="mb-2">
              No debes preocuparte, ingresa tu email y te enviaremos un enlace para restablecer tu contraseña
            </b-card-text>
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form
                class="auth-forgot-password-form mt-2"
                @submit.prevent="validationForm"
              >
                <!-- email -->
                <b-form-group
                  label="Email"
                  label-for="forgot-password-email"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="forgot-password-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false:null"
                      name="forgot-password-email"
                      placeholder="john@ejemplo.com"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- submit button -->
                <b-button
                  variant="primary"
                  block
                  type="submit"
                >
                  Enviar Enlace de Restablecimiento
                </b-button>
              </b-form>
            </validation-observer>
            <b-card-text class="text-center mt-2">
              <b-link :to="{name:'login'}">
                <feather-icon icon="ChevronLeftIcon" /> Volver a login
              </b-link>
            </b-card-text>
          </b-card>
        <!-- /Forgot Password v1 -->
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import DuttonLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    DuttonLogo,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      // validation
      required,
      email,
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.sendResetLink()
        }
      })
    },
    sendResetLink() {
      axios
        .post('forgot-password', {
          email: this.userEmail,
        })
        .then(response => {
          if (response.data.res) {
            this.makeToast('success', 'Éxito', response.data.msg || 'Si el correo existe, recibirás un enlace para restablecer tu contraseña')
            this.userEmail = ''
          } else {
            throw response
          }
        })
        .catch(error => {
          this.makeToast('danger', 'Error', error.response?.data?.msg || error.response?.data?.message || 'No es posible enviar el enlace de restablecimiento')
        })
    },
    makeToast(variant, title, message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: 'EditIcon',
          variant,
          text: message,
        },
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
